import React, { useState } from 'react'
import { isInAppBrowser } from 'utils/inAppBrowserUtils'
import LoginModal from 'components/LoginModal'

/**
 * Starts a teacher sign-up from a team's "join" form.
 *
 * In a regular browser that posts the Google OAuth form with the teacher role.
 * Google refuses OAuth inside an in-app browser, so there the reader gets the
 * site's registration dialog with the role locked to teacher.
 *
 * ⛔ Not TeamPublicPage/LoginModal: its registration creates student accounts,
 * and this reader is a teacher applying to join.
 *
 * `translations` must carry `login_modal`. Render `loginModal` once anywhere in
 * the component's output.
 */
export default function useTeacherJoinLogin(translations) {
  const [isLoginOpen, setIsLoginOpen] = useState(false)

  const startTeacherJoinLogin = () => {
    if (isInAppBrowser()) {
      setIsLoginOpen(true)
      return
    }

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
    const form = document.createElement('form')
    form.method = 'POST'
    form.action = '/users/auth/google_oauth2'

    const csrfInput = document.createElement('input')
    csrfInput.type = 'hidden'
    csrfInput.name = 'authenticity_token'
    csrfInput.value = csrfToken
    form.appendChild(csrfInput)

    const roleInput = document.createElement('input')
    roleInput.type = 'hidden'
    roleInput.name = 'role'
    roleInput.value = 'teacher'
    form.appendChild(roleInput)

    document.body.appendChild(form)
    form.submit()
  }

  const loginModal = (
    <LoginModal
      isOpen={isLoginOpen}
      onClose={() => setIsLoginOpen(false)}
      translations={translations}
      forcedRole="teacher"
      initialState="register"
      redirectUrl={window.location.pathname + window.location.search}
    />
  )

  return { startTeacherJoinLogin, loginModal }
}
